import { useRef } from "react";
import { useLocation } from "react-router-dom";

export function useLocationState<State = { referrer?: string }>() {
  const location = useLocation<State>();

  // workaround location.state reset during loading
  const locationStateRef = useRef<State>();
  if (location?.state) {
    locationStateRef.current = location.state;
  }

  return locationStateRef.current;
}
